import { ReactNode } from "react";

/**
 * Renders resolved Neighbourhood copy, converting `<...>` bold markers (the
 * convention used by every Tolgee-authored string in this section) into
 * `<strong>` elements. Everything outside the markers renders as plain text.
 * Avoids `dangerouslySetInnerHTML` for user-facing, potentially-translated content.
 */
export const renderBoldText = (text: string): ReactNode => {
  if (!text) return text;
  const parts = text.split(/<([^<>]+)>/g);
  return parts.map((part, i) =>
    // The regex capture group lands on odd indices — that's the bold content.
    i % 2 === 1 ? <strong key={i}>{part}</strong> : <span key={i}>{part}</span>,
  );
};

export default renderBoldText;
